import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { DisplayStyle } from './templates/DisplayStyle';
import { PortOrRoomRow } from './templates/PortOrRoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  displayStyle?: DisplayStyle;
};
export const FloorTemperatureLimit = ({ manifold, displayStyle = 'PerPort' }: Props) => {
  return (
    <PortOrRoomRow
      name="Floor Surface Temperature Limit (°C)"
      manifold={manifold}
      getValue={room => room.maximumTemperatureInDegreesCelsius}
      displayStyle={displayStyle}
    />
  );
};
